import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import RemoveService from "pages/afipPaymentLink/servicesPayment/linkedService/RemoveService";
import EditService from "pages/afipPaymentLink/servicesPayment/linkedService/EditService";

const AdheredServicesItem = ({ receivedAdheredService, setDrawer, isDesktop, payScheduledService }) => {

    const options = [
        {
            text: "adheredServices.link.menu.pay",
            textType: "I18N",
            func: () => payScheduledService(),
        },
        {
            text: "adheredServices.link.menu.delete",
            textType: "I18N",
            func: () =>  setDrawer({
                showDrawer: true,
                contentDrawer: (
                    <RemoveService
                        service={receivedAdheredService}
                        setDrawer={setDrawer}
                        isDesktop={isDesktop}
                    />
                ),
            }),
        },
        {
            text: "adheredServices.link.menu.editalias",
            textType: "I18N",
            func: () =>  setDrawer({
                showDrawer: true,
                contentDrawer: (
                    <EditService
                        service={receivedAdheredService}
                        setDrawer={setDrawer}
                        isDesktop={isDesktop}
                    />
                ),
            }),
        },
     
    ];
    return (
        <>
            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.entityName} />
                ) : (
                    <CustomData
                        titleText="adheredServices.link.business"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.entityName}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 2}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.alias ? receivedAdheredService?.alias : "-" } />
                ) : (
                    <CustomData
                        titleText="adheredServices.link.alias"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.alias ? receivedAdheredService?.alias : "-" }
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 3}>
                {isDesktop ? (
                    <CustomText text={receivedAdheredService?.codeLink} />
                ) : (
                    <CustomData
                        titleText="adheredServices.link.paymentCode"
                        titleTextType="I18N"
                        valueText={receivedAdheredService?.codeLink}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 2}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
        </>
    );
};

AdheredServicesItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
    payScheduledService: func.isRequired,
};

export default AdheredServicesItem;
